import photo from '../assets/photo.jpeg';

export const profileData = {
  greeting: ['Hi,', "Hi, I'm Jacob Arychuk"],
  photo: photo,
  about: "Bachelor of Software Engineering — University of Victoria, 2026",
};
